import { Flex, Switch, Text } from "@/atoms"

import styles from "./CloudConnectionStatus.module.scss"

import type { CloudConnectionToggleProps } from "."

// A setting switch with its help right under the label
export const CloudConnectionToggle = (props: CloudConnectionToggleProps) => {
  const { checked, onChange, label, help } = props

  return (
    <label className={styles.toggle}>
      <Switch size="small" checked={checked} onChange={onChange} />
      <Flex vertical gap={2}>
        <Text>{label}</Text>
        {help && <Text type="secondary">{help}</Text>}
      </Flex>
    </label>
  )
}
